"use client"

import { Heading } from "@medusajs/ui"
import CartTotals from "@modules/common/components/cart-totals"
import { HttpTypes } from "@medusajs/types"

type SummaryProps = {
  cart: HttpTypes.StoreCart & {
    promotions: HttpTypes.StorePromotion[]
  }
  shippingOptions?: HttpTypes.StoreCartShippingOption[]
}

const Summary = ({ cart, shippingOptions = [] }: SummaryProps) => {
  return (
    <div className="flex flex-col gap-y-4">
      <Heading
        level="h2"
        className="
          text-[1.45rem]
          font-black
          leading-tight
          tracking-tight
          text-slate-900
        "
      >
        SUMMARY
      </Heading>

      <div
        className="
          rounded-2xl
          border border-slate-200
          bg-white
          px-4 py-4
          shadow-[0_10px_24px_rgba(15,23,42,0.6)]
          [&_*]:text-[0.95rem]
          [&_*]:font-semibold
          [&_[data-testid='cart-total']]:text-[1.35rem]
          [&_[data-testid='cart-total']]:font-black
        "
      >
        <CartTotals totals={cart} shippingOptions={shippingOptions} />
      </div>
    </div>
  )
}

export default Summary
